import React from 'react';
import { useHrAccess } from '../../../services/authentication/HrAccess';
import { Offers_Board } from './Offers_Board';

export default function Agency_Board(props) {
    const { permissions } = useHrAccess();
    return (
        <Offers_Board
            {...props}
            boardMode="agency"
            canManageFakeOffers={permissions.hasFullAccess && permissions.hasAcceptedTeamMembership}
        ></Offers_Board>
    );
}

export { Agency_Board };
